import { Add as AddIcon, Delete } from "@mui/icons-material";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { VALIDATION_TYPES } from "common/constants/enums";
import { handleNodeState } from "common/constants/functions";
import _ from "lodash";

const Validations = ({ nodeState, setNodeState }: any) => {
  const handleAddValidation = () => {
    setNodeState((prev: any) => {
      const newState = _.cloneDeep(prev); // Deep clone the previous state to avoid mutation
      _.set(newState, "data.properties.properties.validations", [
        ..._.get(newState, "data.properties.properties.validations", []),
        { type: "", value: "", message: "" },
      ]);
      return newState;
    });
  };
  const handleDeleteValue = (index: number) => {
    setNodeState((prev: any) => {
      const newState = _.cloneDeep(prev); // Deep clone the previous state to avoid mutation
      const validations = _.get(newState, "data.properties.properties.validations", []);
      _.set(
        newState,
        "data.properties.properties.validations",
        validations.filter((_: any, i: any) => i !== index)
      );
      return newState;
    });
  };
  return (
    <>
      <Typography variant="subtitle1" sx={{ mt: 1 }}>
        Validations
      </Typography>
      {nodeState?.data?.properties?.properties?.validations?.map((val: any, i: number) => (
        <Box sx={{ display: "flex", gap: 1, my: 2 }} key={i}>
          <Box sx={{ flexWrap: "wrap", display: "flex" }}>
            <FormControl sx={{ width: "calc(50% - 8px)", mr: 1 }}>
              <InputLabel id="type">Type *</InputLabel>

              <Select
                required
                labelId="type"
                name="type"
                value={nodeState?.data?.properties?.properties?.validations?.[i]?.type || ""}
                label="Type *"
                fullWidth
                onChange={({ target: { name, value } }: any) =>
                  handleNodeState(
                    ["data", "properties", "properties", "validations", i, name],
                    value,
                    setNodeState
                  )
                }
              >
                {Object.keys(VALIDATION_TYPES)?.map((key: string) => (
                  <MenuItem key={key} value={VALIDATION_TYPES[key]}>
                    {VALIDATION_TYPES[key]}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              required
              name="value"
              label="Value"
              type="text"
              value={nodeState?.data?.properties?.properties?.validations?.[i]?.value}
              sx={{ width: 1 / 2 }}
              onChange={({ target: { name, value } }: any) =>
                handleNodeState(
                  ["data", "properties", "properties", "validations", i, name],
                  value,
                  setNodeState
                )
              }
            />
            <TextField
              required
              sx={{ mt: 1 }}
              name="message"
              label="Message"
              type="text"
              value={nodeState?.data?.properties?.properties?.validations?.[i]?.message}
              fullWidth
              onChange={({ target: { name, value } }: any) =>
                handleNodeState(
                  ["data", "properties", "properties", "validations", i, name],
                  value,
                  setNodeState
                )
              }
            />
          </Box>
          <Button
            color="error"
            size="small"
            sx={{ minWidth: "max-content" }}
            onClick={() => handleDeleteValue(i)}
          >
            <Delete />
          </Button>
        </Box>
      ))}
      <Button size="small" onClick={handleAddValidation}>
        <AddIcon sx={{ mr: 0.5 }} />
        Validation
      </Button>
    </>
  );
};

export default Validations;
